<template>
  <div>
    <FunctionalLocationTree
      ref="tree"
      :tree-items="treeItems"
      @view="dialog?.open($event.item.id)"
      @remove="removeItem($event)"
    />
    <FunctionalLocationDialog ref="dialog" @change="tree?.refresh($event)" />
  </div>
</template>

<script setup lang="ts">
import { FunctionalLocation } from "@/classes";
import FunctionalLocationDialog from "@/components/functional-location/FunctionalLocationDialog.vue";
import FunctionalLocationTree from "@/components/functional-location/tree/FunctionalLocationTree.vue";
import { TreeItem } from "@/components/functional-location/tree/tree";
import { useFilterStore } from "@/store/filter";
import { ref, watch } from "vue";

const filters = useFilterStore();
filters.initialise("functional-location-tree", [
  {
    label: "No Sup. Func. Loc.",
    value: "no_superior_functional_location",
    type: "boolean",
    default: true,
  },
  {
    label: "Func. Loc. Description",
    value: "functional_location_description",
    type: "string",
  },
]);

const dialog = ref<InstanceType<typeof FunctionalLocationDialog> | null>(null);
const tree = ref<InstanceType<typeof FunctionalLocationTree> | null>(null);

const treeItems = ref<TreeItem<FunctionalLocation>[]>([]);

watch(
  () => filters.values,
  async () => {
    const flocs = await FunctionalLocation.getTreeChildren({
      parent_id: null,
      ...filters.values,
    });
    treeItems.value = flocs.map((floc) => {
      return {
        item: floc,
        expanded: false,
        children: null,
      } as TreeItem<FunctionalLocation>;
    });
  },
  { deep: true, immediate: true },
);

const removeItem = (treeItem: TreeItem<FunctionalLocation>) => {
  treeItems.value = treeItems.value.filter(
    (item) => item.item.id !== treeItem.item.id,
  );
};
</script>
